import { Component, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { RouteCompress, SectorCompress } from '../../../@core/models/live-route';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { DropoffpointService } from '../../../@core/services/dropoffpoint.service';
import { PudoService } from '../../../@core/services/pudo.service';
import { SectorService } from '../../../@core/services/sector.service';
import { DriverDialogComponent } from '../driver-dialog/driver-dialog.component';

@Component({
  selector: 'pudo-dealer-map-dialog',
  templateUrl: './pudo-dealer-map-dialog.component.html',
  styleUrls: ['./pudo-dealer-map-dialog.component.scss']
})
export class PudoDealerMapDialogComponent implements OnInit {
  // google maps zoom level
  zoom: number = 16;
  // initial center position for the map
  lat: number = 45.500922;
  lng: number = -73.443143;
  greenIcon: string = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
  redIcon: string = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png';

  @Input() PostalCode: string;
  constructor(
    public _pudoService: PudoService,
    public _dropOffPoint: DropoffpointService,
    public _sectorService: SectorService,
    private apiProvider: ApiProvider,
    private dialogRef: MatDialogRef<DriverDialogComponent>
  ) {}

  ngOnInit() {
    this.setCurrentLocation();
    this._dropOffPoint.initialiseDropOffPoint();
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 13;
      });
    }
  }

  resetRouteId() {
    this._dropOffPoint.RouteID = 0;
    this._dropOffPoint.initialiseDropOffPoint();
  }

  close() {
    this.dialogRef.close(false);
  }

  searchPudo() {
    this._pudoService.initialiseDealers(this.PostalCode);
  }

  public updateDropOffPoint(event, m) {
    this.apiProvider.UpdateDropOffPointByRoute(this._dropOffPoint.RouteID, m.DropOffPointID, 1).subscribe(
        aaa => {
          this._sectorService.currentSectorValue.RouteCompress.find( (x) => x.Route_ID === this._dropOffPoint.RouteID).DropOffPointID = m.DropOffPointID;
          this.dialogRef.close(false);
        }
    );
  }
}
